const cleanRedirectUrl = (url = '', token = '') => {
  const cleanedUrl = new URL(url, 'http://localhost');
  cleanedUrl.searchParams.delete('modal');
  cleanedUrl.searchParams.delete('toast');
  cleanedUrl.searchParams.delete('message');
  cleanedUrl.searchParams.delete('email');
  cleanedUrl.searchParams.delete('redirect_to');
  if (token) {
    cleanedUrl.searchParams.set('jwt_token', token);
  } else {
    cleanedUrl.searchParams.delete('jwt_token');
  }

  return cleanedUrl.pathname + cleanedUrl.search;
};

export default cleanRedirectUrl;
